/* eslint-disable no-unused-expressions */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-restricted-syntax */
import BaseFeature from '../../foundation/base/base';
import { detectBrowser, Browsers } from '../../foundation/utilities/detectBrowsers';

const dataSelector = 'data-anchor';
const anchorItemTemplate = `<li class="m-anchor-list__item u-grid--horizontal" data-ref="{{id}}">
								<a tabindex="0" class="m-anchor-list__item-link" href="#{{id}}" title="{{title}}">
									<span class="m-anchor-list__item-text">{{title}}</span>
								</a>
								<span class="m-anchor-list__divider"></span>
							</li>`;

export default class AnchorList extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = this.element;
		this.sections = document.querySelectorAll(`[${dataSelector}]`);

		this.anchors = this.getAnchors();
		this.populateAnchors();

		this.anchorLinks = this.el.querySelectorAll('[data-ref]');
		this.itemLinks = this.el.querySelectorAll('.m-anchor-list__item-link');

		this.addEventListener();
	}

	// Get links from sections on page
	getAnchors() {
		const anchors = [];
		for (const section of this.sections) {
			anchors.push({
				id: section.getAttribute('id'),
				title: section.getAttribute(`${dataSelector}`)
			});
		}
		return anchors;
	}

	populateAnchors() {
		for (const anchor of this.anchors) {
			const anchorItem = this.prepareAnchor(anchor.id, anchor.title);
			this.el.insertAdjacentHTML('beforeend', anchorItem);
		}
	}

	// Prepare a single anchorItem
	prepareAnchor(anchorId, anchorTitle) {
		// console.log('anchorId', anchorId)
		let anchorItemCopy = anchorItemTemplate;
		// Replace id placeholder globally
		anchorItemCopy = anchorItemCopy.replace(/{{id}}/g, anchorId);
		anchorItemCopy = anchorItemCopy.replace(/{{title}}/g, anchorTitle);
		return anchorItemCopy;
	}

	addEventListener() {
		if (this.anchorLinks) {
			this.anchorLinks.forEach((element) => {
				element.addEventListener('click', e => this.attachScroll(e, element));
			});
		}

		if (this.itemLinks) {
			for (let i = 0; i < this.itemLinks.length; i++) {
				const item = this.itemLinks[i];
				item.classList.add('m-anchor-list__item-link--hide-outline');

				item.addEventListener('click', () => {
					item.classList.add('m-anchor-list__item-link--hide-outline');
				});

				item.addEventListener('keyup', (e) => {
					if (e.code === 'Tab') {
						item.classList.remove('m-anchor-list__item-link--hide-outline');
					}
				});
			}
		}
	}

	attachScroll(e, anchorLink) {
		e.preventDefault();
		const scrollSpeed = 5;

		// Get target element
		const anchorTarget = this.getTarget(anchorLink);

		// Get distance from top
		let targetPosition = this.getTargetPosition(anchorTarget);

		const isIE = detectBrowser(Browsers.IE);

		let scrollSizeY = isIE
			? document.documentElement.scrollTop // Fix for IE11
			: window.scrollY; // Other browsers can use window.scrollY

		// Get correct scrolling distance
		targetPosition += scrollSizeY;

		// Get scroll direction
		const isScrollingDown = targetPosition >= scrollSizeY;

		const scroll = setInterval(() => {
			isScrollingDown
				? scrollSizeY += this.getScrollingSpeed(isScrollingDown, scrollSizeY, targetPosition)
				: scrollSizeY -= this.getScrollingSpeed(isScrollingDown, scrollSizeY, targetPosition);

			window.scrollTo(0, scrollSizeY);

			if (isScrollingDown) {
				if (scrollSizeY >= targetPosition) {
					clearInterval(scroll);
				}
			} else if (scrollSizeY <= targetPosition) {
				clearInterval(scroll);
			}
		}, scrollSpeed);
	}

	getTarget(anchorLink) {
		return anchorLink.getAttribute('data-ref');
	}

	getTargetPosition(anchorTarget) {
		const target = document.querySelector(`[id="${anchorTarget}"]`);
		const targetPosition = target.getBoundingClientRect().top;
		return targetPosition;
	}

	getScrollingSpeed(isScrollingDown, currentPosition, targetPosition) {
		const threshold = 500;
		const scrollDistance = {
			sm: 7.5,
			lg: 20
		};

		const difference = isScrollingDown
			? targetPosition - currentPosition
			: currentPosition - targetPosition;
		return difference > threshold ? scrollDistance.lg : scrollDistance.sm;
	}
}
